import { forwardRef, ReactElement } from 'react';
import cn from 'classnames';
import styles from './LandingStartBlock.module.scss';
import { Heading } from '../../Heading/Heading';
import { Button, ButtonProps } from '../../Button/Button';
import { LandingBlock, LandingBlockProps } from '../LandingBlock/LandingBlock';

export interface LandingStartBlockProps extends LandingBlockProps {
  title: string;
  subtitle?: string;
  description?: string;
  eyebrow?: string;
  localChildren?: ReactElement;
  button1?: ButtonProps;
  button2?: ButtonProps;
}

export const LandingStartBlock = forwardRef<
  HTMLElement,
  LandingStartBlockProps
>(
  (
    {
      title,
      button1 = null,
      button2 = null,
      description,
      eyebrow,
      subtitle,
      localChildren,
      ...props
    }: LandingStartBlockProps,
    ref
  ) => {
    const renderButtons = () => {
      return (
        <div className={styles.actions}>
          {button1 && (
            <Button
              className={styles['hero-button']}
              btnStyle="primary"
              {...button1}
            />
          )}
          {button2 && (
            <Button
              className={cn(styles['hero-button'], styles.b)}
              btnStyle="secondary"
              {...button2}
            />
          )}
        </div>
      );
    };

    return (
      <LandingBlock classname={styles.block} {...props} ref={ref}>
        <div className={styles.root}>
          <div className={styles.copy}>
            {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
            <Heading
              className={cn(styles.title, !subtitle && styles['only-title'])}
              headingLevel="h1"
            >
              {title}
            </Heading>
            {subtitle && (
              <Heading className={styles.subtitle} headingLevel="h2">
                {subtitle}
              </Heading>
            )}
            {description && <p className={styles.description}>{description}</p>}
            {renderButtons()}
            <div className={styles.highlights} aria-label="Practice highlights">
              <span>Functional medicine</span>
              <span>Orthomolecular care</span>
              <span>Ajijic, Jalisco</span>
            </div>
          </div>
          <div className={styles.visual} aria-hidden={!localChildren}>
            <div className={styles['visual-inner']}>{localChildren}</div>
          </div>
        </div>
      </LandingBlock>
    );
  }
);

LandingStartBlock.displayName = 'LandingStartBlock';
